(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const enhanceProductMedia = (root = document) => {
    root.querySelectorAll('.product-media--slider').forEach((productMedia) => {
      if (productMedia.dataset.rrContinuousGallery === 'true') return;

      const gallery = productMedia.querySelector('media-gallery');
      const viewer = gallery?.querySelector('.media-viewer');
      const counter = gallery?.querySelector('.media-ctrl__current-item');
      const grid = productMedia.querySelector('.rr-product-media-grid');
      const previousButton = gallery?.querySelector('.media-ctrl__btn[name="prev"]');
      const nextButton = gallery?.querySelector('.media-ctrl__btn[name="next"]');
      const slides = viewer ? Array.from(viewer.querySelectorAll(':scope > .media-viewer__item')) : [];
      const productInfo = productMedia.closest('.product')?.querySelector('.product-info');

      if (!gallery || !viewer || !counter || !grid || !previousButton || !nextButton || slides.length < 2) return;

      const syncColumnHeight = () => {
        if (!productInfo || window.innerWidth < 769) {
          productMedia.style.minHeight = '';
          return;
        }
        productMedia.style.minHeight = `${productInfo.offsetHeight}px`;
      };

      syncColumnHeight();
      window.addEventListener('resize', syncColumnHeight, { passive: true });
      if ('ResizeObserver' in window && productInfo) {
        new ResizeObserver(syncColumnHeight).observe(productInfo);
      }

      const gridItems = new Map(
        Array.from(grid.querySelectorAll('.rr-product-media-grid__item')).map((item) => [item.dataset.mediaId, item])
      );

      gridItems.forEach((item, mediaId) => {
        item.addEventListener('click', () => {
          const targetSlide = slides.find((slide) => slide.dataset.mediaId === mediaId);
          if (!targetSlide) return;

          gallery.customSetActiveMedia(targetSlide, false);
          const lightboxTrigger = targetSlide.querySelector('gallery-zoom-open');
          if (lightboxTrigger) lightboxTrigger.click();
        });
      });

      const currentIndex = () => {
        const value = Number.parseInt(counter.textContent, 10) - 1;
        return Number.isFinite(value) && value >= 0 ? value : 0;
      };

      const prepareFixedGrid = () => {
        const visibleItems = [];

        gridItems.forEach((item, mediaId) => {
          item.hidden = mediaId === slides[0].dataset.mediaId;
          item.classList.remove('rr-product-media-grid__item--wide');
          if (!item.hidden) visibleItems.push(item);
        });

        visibleItems.forEach((item, index) => {
          if (index % 3 === 2) item.classList.add('rr-product-media-grid__item--wide');
        });

        if (visibleItems.length % 3 === 1) {
          visibleItems[visibleItems.length - 1].classList.add('rr-product-media-grid__item--wide');
        }
      };

      const showSlide = (direction) => {
        const activeIndex = currentIndex();
        const targetIndex = (activeIndex + direction + slides.length) % slides.length;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const wrapsGallery = Math.abs(targetIndex - activeIndex) > 1;

        if (direction < 0 && activeIndex === 0 && !reducedMotion) {
          const lastSlideCopy = slides[slides.length - 1].cloneNode(true);
          let completed = false;

          lastSlideCopy.removeAttribute('id');
          lastSlideCopy.setAttribute('aria-hidden', 'true');
          viewer.prepend(lastSlideCopy);
          viewer.scrollTo({ left: slides[0].offsetLeft, behavior: 'auto' });

          const maintainCounter = () => {
            counter.textContent = String(slides.length);
          };

          const completeWrap = () => {
            if (completed) return;
            completed = true;
            viewer.removeEventListener('scroll', maintainCounter);
            lastSlideCopy.remove();
            viewer.scrollTo({ left: slides[slides.length - 1].offsetLeft, behavior: 'auto' });
            counter.textContent = String(slides.length);
          };

          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              viewer.addEventListener('scroll', maintainCounter);
              viewer.addEventListener('scrollend', completeWrap, { once: true });
              window.setTimeout(completeWrap, 700);
              viewer.scrollTo({ left: lastSlideCopy.offsetLeft, behavior: 'smooth' });
            });
          });
          return;
        }

        if (direction > 0 && activeIndex === slides.length - 1 && !reducedMotion) {
          const firstSlideCopy = slides[0].cloneNode(true);
          let completed = false;

          firstSlideCopy.removeAttribute('id');
          firstSlideCopy.setAttribute('aria-hidden', 'true');
          viewer.append(firstSlideCopy);

          const maintainCounter = () => {
            counter.textContent = '1';
          };

          const completeWrap = () => {
            if (completed) return;
            completed = true;
            viewer.removeEventListener('scroll', maintainCounter);
            viewer.scrollTo({ left: slides[0].offsetLeft, behavior: 'auto' });
            firstSlideCopy.remove();
            counter.textContent = '1';
          };

          viewer.addEventListener('scroll', maintainCounter);
          viewer.addEventListener('scrollend', completeWrap, { once: true });
          window.setTimeout(completeWrap, 700);
          viewer.scrollTo({ left: firstSlideCopy.offsetLeft, behavior: 'smooth' });
          return;
        }

        viewer.scrollTo({
          left: slides[targetIndex].offsetLeft,
          behavior: reducedMotion || wrapsGallery ? 'auto' : 'smooth'
        });
        counter.textContent = String(targetIndex + 1);
      };

      const keepEnabled = () => {
        previousButton.disabled = false;
        nextButton.disabled = false;
      };

      previousButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        showSlide(-1);
      }, true);

      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        showSlide(1);
      }, true);

      const buttonObserver = new MutationObserver(keepEnabled);
      buttonObserver.observe(previousButton, { attributes: true, attributeFilter: ['disabled'] });
      buttonObserver.observe(nextButton, { attributes: true, attributeFilter: ['disabled'] });

      productMedia.dataset.rrContinuousGallery = 'true';
      keepEnabled();
      prepareFixedGrid();
    });
  };

  enhanceProductMedia();
  document.addEventListener('shopify:section:load', (event) => enhanceProductMedia(event.target));

  } catch(e) { console.error(e); }
})();
})();
